import * as React from 'react';
import Typography from '@material-ui/core/Typography';

import { useStyles } from './styles';

/**
 * @param {Object} props
 * @param {undefined} props.children
 */
const NumberedForm = ({ children }) => {
  const classes = useStyles();

  return <ol className={classes.list}>{children}</ol>;
};

/**
 * @param {Object} props
 * @param {string} props.title
 * @param {boolean} [props.showTitleGutter]
 * @param {undefined} props.children
 * @param {undefined} [props.action]
 */
const NumberedFormItem = ({ title, showTitleGutter, children, action }) => {
  const classes = useStyles();

  return (
    <li className={classes.item}>
      <div className={classes.headerContainer}>
        <Typography variant="subtitle1" gutterBottom={showTitleGutter}>
          {title}
        </Typography>
        {action && <div>{action}</div>}
      </div>
      <div className={classes.itemContent}>{children}</div>
    </li>
  );
};

NumberedFormItem.defaultProps = {
  showTitleGutter: true,
  action: undefined
};

NumberedForm.Item = NumberedFormItem;

/**
 * @param {props} props
 */
const NumberedFormContainer = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={classes.item}>
      <div className={classes.itemContent}>{children}</div>
    </div>
  );
};

NumberedForm.Container = NumberedFormContainer;

export default NumberedForm;
